<template>
    <TheHeader/>
    <router-view v-slot="{ Component }">
        <template v-if="Component">
            <keep-alive>
                <suspense>
                    <template #default>
                        <component :is="Component"></component>
                    </template>
                    <template #fallback>
                        <div style="min-height: 30vh">
                            <BaseSpinner></BaseSpinner>
                        </div>
                    </template>
                </suspense>
            </keep-alive>
        </template>
    </router-view>
    <TheFooter/>
</template>

<script>
import TheHeader from './components/TheHeader.vue';
import TheFooter from './components/TheFooter.vue';
import HelpBox from './components/HelpBox.vue';

export default {
    name: 'App',
    components: {TheHeader, TheFooter}
}
</script>
